import { Flex, FormattedDateTime, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../utils'
import * as Styled from './styles'

interface FormattedDateTimeWithDelimiterProps {
  dateOnly?: boolean
  separator?: string
  value: string | Date
}

const DATE_TIME_SEPARATOR = '·'

export const FormattedDateTimeWithDelimiter = ({
  dateOnly = false,
  separator = DATE_TIME_SEPARATOR,
  value,
}: FormattedDateTimeWithDelimiterProps): ReactElement => {
  const locale = getCurrentLocale()
  const date = new Date(value)

  return (
    <Flex as="span" gap={Spacing.S4}>
      <FormattedDateTime.Date locale={locale} value={date} />
      {!dateOnly && (
        <>
          <Styled.DateTimeSeparator>{separator}</Styled.DateTimeSeparator>
          <FormattedDateTime.Time locale={locale} value={date} />
        </>
      )}
    </Flex>
  )
}
